import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Anuj Rathore. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
